import _ from 'lodash'
import React from 'react'

import { Typography } from '@material-ui/core'
import styled from 'styled-components'
import { ConcreteSensor } from '../../../types'
import LevelBox, {
  ColBox,
  ColTitleBox,
  Content,
  LevelBoxLabel,
} from './LevelBox'

type Props = {
  sensors: { [i: number]: ConcreteSensor }
  completeTimeVisible?: boolean
  isFreshWater?: boolean
}

const RegistanceTable = (props: Props) => {
  return (
    <Content>
      <ColTitleBox>
        <LevelBoxLabel>
          <Typography align="center" color="inherit">
            コンクリート
          </Typography>
        </LevelBoxLabel>
        <LevelBoxLabel>
          {props.isFreshWater ? (
            <WaterLabelRow>
              <Typography color="inherit">水</Typography>
              <WaterLegend>
                <FreshWaterLabel>(緑:淡水)</FreshWaterLabel>
                <BleedingLabel>(青:ﾌﾞﾘｰﾃﾞｨﾝｸﾞ)</BleedingLabel>
              </WaterLegend>
            </WaterLabelRow>
          ) : (
            <Typography align="center" color="inherit">
              水
            </Typography>
          )}
        </LevelBoxLabel>
        <LevelBoxLabel>
          <Typography align="center" color="inherit">
            空気
          </Typography>
        </LevelBoxLabel>
        <div></div>
      </ColTitleBox>
      <div style={{ display: 'flex', flex: 1, height: '100%' }}>
        {_.map(props.sensors, (sensor, i) => (
          <ColBox key={i}>
            <RegistanceLevelBox num={i} sensor={sensor} />
          </ColBox>
        ))}
      </div>
    </Content>
  )
}

const NumBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px white;
  margin: 4px 2px 2px;
`

const WaterLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 0 4px;
`

const WaterLegend = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 1.2;
  text-align: left;
  font-weight: bold;
`

const FreshWaterLabel = styled.span`
  color: yellowgreen;
`

const BleedingLabel = styled.span`
  color: lightblue;
`

const RegistanceLevelBox = ({
  sensor,
  num,
}: {
  sensor: ConcreteSensor
  num: string
}) => (
  <div
    style={{
      height: '100%',
      display: 'grid',
      gridTemplateRows: '80% 20%',
    }}
  >
    <div style={{ height: '100%', display: 'grid' }}>
      <LevelBox data-level={sensor.level} />
      <LevelBox data-level={sensor.level} />
      <LevelBox data-level={sensor.level} />
    </div>
    <NumBox>
      <Typography align="center" color="inherit">
        {Number(num) + 1}
      </Typography>
    </NumBox>
  </div>
)

export default RegistanceTable
